import { v4 as uuidv4 } from 'uuid';

/**
 * Cleans the page level script config data by removing specified keys.
 * @param {Array} pageLevelScriptConfig - The array of page level script config objects.
 * @returns {Array} An array of cleaned page level script config objects.
 */
export const cleanPageLevelScriptConfigData = (pageLevelScriptConfig) => {
	const keysToRemove = ['isDeletable'];

	const cleanedData = pageLevelScriptConfig.map((item) => {
		const cleanedItem = { ...item }; // Create a copy of the item
		keysToRemove.forEach((key) => {
			delete cleanedItem[key]; // Remove the specified keys
		});
		return cleanedItem;
	});

	return cleanedData;
};

/**
 * Generates a new page object for page level script config
 * with a unique ID and default values.
 * @returns {Object} A new page level script config object.
 */
export const getNewPageObjectForPageLevelScriptConfig = () => {
	return {
		id: uuidv4(),
		pageUrl: '',
		pageLevelScriptConfig: {
			sectionLevelSplit: {
				enabled: false,
				splits: {}
			}
		},
		isDeletable: true
	};
};

/**
 * Processes page level config array data from a mapping.
 * @param {Object} pageLevelConfig - The object containing page level configs.
 * @returns {Array} An array of processed page level config objects.
 */
export const getProcessedPageLevelConfigArrDataFromMapping = (pageLevelConfig) => {
	const configArr = [];
	for (let pageUrl in pageLevelConfig) {
		configArr.push({
			id: uuidv4(),
			pageUrl,
			pageLevelScriptConfig: pageLevelConfig[pageUrl]
		});
	}
	return configArr;
};
